export default "__VITE_ASSET__BQOom$WR__"